
import '../App.css';
import '../Css/Services.css';
import data from '../JsonFiles/Services.json';
import ServicesDescription from './ServicesSections/ServicesDescription';

export default function Services() {

    return (
        <div>
            <div className='title'>
                <div className='big-title'>Ce que nous proposons</div>
            </div>
            <div className='services-container'>
                {
                    data.services.map((item,i) => (
                        <ServicesDescription key={i} nom={item.id} orientation={i} title={item.title} description={item.description} image={item.image}></ServicesDescription>
                    ))     
                }
            </div>
        </div>
       
    );
}